import { WSEmptyState } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";

export const TableNoDataMessage: React.FC<{
  search?: string;
  isFiltered?: boolean;
  isProcessing?: boolean;
}> = ({ search, isFiltered, isProcessing }) => {
  const history = useHistory();

  if (search || isFiltered) {
    return (
      <WSEmptyState
        type="search"
        title={search ? `No results for ‘${search}’` : `No results`}
        description="Clear search and filters to see all items."
        actions={{
          buttons: [
            {
              onClick: () => {
                history.push(history.location.pathname);
              },
              label: "Clear search and filters",
              kind: "Tertiary"
            }
          ]
        }}
      />
    );
  }

  if (isProcessing) {
    return (
      <WSEmptyState
        type="tasks"
        title="We're processing your tax forms."
        description="Your tax forms have been generated and will appear here shortly."
      />
    );
  }

  return (
    <WSEmptyState
      type="search"
      title="Nothing's here yet."
      description="No 1099 forms found."
    />
  );
};
